import { useRef, useState, useLayoutEffect } from 'react';
export function useGridWidth(width) {
  var gridRef = useRef(null);

  var _useState = useState(0),
      gridWidth = _useState[0],
      setGridWidth = _useState[1];

  useLayoutEffect(function () {
    // Do not calculate the width if width is provided
    if (typeof width === 'number') return;

    function onResize() {
      // Immediately re-render when the component is mounted to get valid columnMetrics.
      setGridWidth(gridRef.current.getBoundingClientRect().width);
    }

    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [width]);
  return [gridRef, width || gridWidth];
}